var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11098 0.989592C2.52519 0.403806 1.57544 0.403806 0.989656 0.989592C0.403869 1.57538 0.403869 2.52513 0.989656 3.11091L4.87874 7L0.989656 10.8891C0.403869 11.4749 0.403869 12.4246 0.989656 13.0104C1.57544 13.5962 2.52519 13.5962 3.11098 13.0104L7.00006 9.12132L10.8892 13.0104C11.4749 13.5962 12.4247 13.5962 13.0105 13.0104C13.5963 12.4246 13.5963 11.4749 13.0105 10.8891L9.12138 7L13.0105 3.11091C13.5963 2.52513 13.5963 1.57538 13.0105 0.989592C12.4247 0.403806 11.4749 0.403805 10.8892 0.989592L7.00006 4.87868L3.11098 0.989592Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0dc709ff0ef7b2c1fa2e5bba5d7c8249.svg";
export { ForwardRef as ReactComponent };